import script from "./ShowPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShowPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__